export enum AcknowledgmentKey {
    CasiBetaAccess = "CasiBetaAccess",
}
